import React from "react";
import Div from "../Div";

const partnerLogos = [
  {
    src: "/images/net.png",
    alt: ".NET - Backend",
  },
  {
    src: "/images/springboot.png",
    alt: "Spring Boot - Backend",
  },
  {
    src: "/images/flutter.png",
    alt: "Flutter - Mobile Development",
  },
  
  {
    src: "/images/laravel.png",
    alt: "Laravel - Backend",
  },
  {
    src: "/images/react.png",
    alt: "React - Frontend",
  },


];

export default function LogoList() {
  return (
    <Div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "20px",
      }}
    >
      {partnerLogos.map((partnerLogo, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "120px",
            height: "120px",
          }}
        >
          <img
            src={partnerLogo.src}
            alt={partnerLogo.alt}
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "100px",
              objectFit: "contain",
            }}
          />
        </div>
      ))}
    </Div>
  );
}
